import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";

export const offlineDataApi = createApi({
    reducerPath: "offlineDataApi",
    tagTypes: ["OfflineDataPlatforms"],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getOfflineDataPlatforms: builder.query({
            query: ({ clientName, clientRegion }) => ({
                url: "/offline_data/platforms",
                method: "GET",
                params: {
                client_name: clientName,
                client_region: clientRegion
                },
            }),
            providesTags: ["OfflineDataPlatforms"],
        }),
    }),
    });

export const { useGetOfflineDataPlatformsQuery } = offlineDataApi;

export default offlineDataApi.reducer;